export default [
  {
    path: '/user/edit',
    name: 'user-edit',
    component: () => import('@/views/users/CreateUser.vue'),
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/users/UserList.vue'),
  },
]
